import React from 'react';
import Radium from 'radium';
import {Container} from 'flux/utils';

import HeaderContainer from 'containers/HeaderContainer';

import HttpService from 'service/HttpService';
import OrderStore from 'stores/OrderStore';
import ProductStore from 'stores/ProductStore';

import AppConstants from 'AppConstants';
import AppUtil from 'AppUtil';
import {A, Button, Img} from 'views/AppElements';
import {Helmet} from "react-helmet";
import Footer from 'views/Footer';

import {Separator} from 'views/AppElements';
import { Sticky } from 'react-sticky';

import DateComponent from 'views/DateComponent';

import copy from 'copy-to-clipboard';
import ProductList from 'views/product/ProductList';

import Modal from 'react-responsive-modal';
import AdAPI from 'service/api/AdAPI';
import { OrderAction } from 'AppAction';

import 'css/ad.css';


const CAMPAIGN_URL = AppConstants.WEBSITE + "/chetan-vlog-camper";


const CHETAN_STORE = "Chetan Vlog";

const TOTAL_ORDERS_TARGET = 100;

export const DCUtil = {
    isCampaignActive: function() {
        const today = new Date();
        const endDate = this.campaignEndDate();
        return today.getTime() < endDate.getTime();
    },

    campaignStartDate: function() {
        //Aug 29
        return new Date(2021, 1, 19);
    },
    campaignEndDate: function() {
        //Sep 30
        return new Date(2022, 1, 19);
    }
};

const ContributersList = (props) => {
    const contributers = props.contributers;
    
    if(contributers === null || contributers.size === 0)
        return <div id="firstToContribute">- Be the First to Contribute!</div>;

    console.log("contributers", contributers);
    //Ram hari Bought one Gorkhali Hustle Tshirt
    const contributersLi = contributers.map(c => {
        const productURL = AppUtil.getProductURL(c.product);
        const delivered = c.orderState === AppConstants.ORDER_STATE.DELIVERED.value;

        let donationInfo = null;
        if(delivered) {
            donationInfo = <span className="donatedInfo deliveredInfo"><i className="fa fa-check-circle" aria-hidden="true"></i> {c.quantity} order profit donated to campaign.</span>;
        } else {
            donationInfo = <span className="donatedInfo pendingDeliveryInfo"><i className="fa fa-exclamation-circle" aria-hidden="true"></i> Pending Delivery.</span>;
        }
        
        const productStr = <A href={productURL}>{c.product.title}</A>;
        return <li key={c.orderId} className="eachContributer">
                    <b>{c.user.username}</b> bought {c.quantity} {productStr} {AppConstants.PRODUCT_TYPES[c.product.productType].label} <small>on <DateComponent date={c.createdDate} relative={false} /></small>
                    <br />
                    {donationInfo}
                </li>
    });
    return <ul id="contributersList">
            {contributersLi}
    </ul>
};



const FeaturedProductsModal = (props) => {
    const products = props.products;

    return <Modal closeOnOverlayClick={false} open={props.open} 
            onClose={props.onClose} 
            classNames={{ modal: 'dashain-campaign-modal', closeIcon: 'dashain-campaign-close-icon' }}>
                <div>
                    <ProductList products={products} showSlider={true} 
                                    title={CHETAN_STORE+" Merchandise"} 
                                    productViewMode="productOnly" navigator="arrows" 
                                    infinite={true}
                                    autoplay={false} id="featuredProducts" flattenProductImages={true}/>

                    <Separator style={{margin: '25px auto', width: '50%'}} />
                    <p id="chetanCamperSupportMsg">Support Chetan Vlog by Purchasing one of his Merchandise. <b>Every Profit made will go directly to help him build his Camper.</b></p>
                </div>
        </Modal>
};

const CampaignStat = Radium((props) => {
    const campaignStat = props.campaignStat;

    return <div style={props.style} id="campaignStat">
                {
                    DCUtil.isCampaignActive() && 
                    <div>
                        <h1 id="tshirtRemaining"><b>{campaignStat.totalRemaining}</b> Orders Remaining</h1>

                        <Separator style={{margin: '0px auto 25px auto', width: '100%'}} />
                        <h4 id="tshirtFulfilled"><b>{campaignStat.totalFulfilled}/<small>100</small> Orders Fulfilled</b></h4>
                    </div>
                }
                
                {
                    !DCUtil.isCampaignActive() && 
                    <div>
                        <h1 id="tshirtFulfilled"><b>{campaignStat.totalFulfilled}/<small>100</small> Orders Fulfilled</b></h1>
                    </div>
                }
                
                <Button onClick={props.onContributeNowClick} mui='true' color='primary' style={{width: '100%'}} className="contributeNowBtn">Contribute Now</Button>

                <h3 style={{textAlign: 'center'}}><b>You Can Also Help by Sharing!</b></h3>
                <Separator style={{margin: '0px auto 25px auto', width: '100%'}} />
                
                <h4 style={{fontSize: '90%', color: 'gray'}}>
                    <i className="fa fa-exclamation-circle" aria-hidden="true"></i> Use the link below to share on Facebook, Twitter, Blog and other platforms.
                </h4>
                <div className="flexRow">
                        <input id="campaignLinkInput" type="text" value={CAMPAIGN_URL} readOnly={true} style={{flexGrow: '1', padding: '5px 10px'}}/>
                        <Button id="copyLinkBtn" onClick={props.onCopy}><i className="fa fa-files-o" aria-hidden="true" /> Copy</Button>
                </div>
                {
                    props.copied &&
                    <small>Copied. You can paste it now.</small>
                }
                
                <div id="socialShareBtns" className="flexRow">
                    <A className="fbLink" href="https://www.facebook.com/" mui='true'><i className="fa fa-facebook" aria-hidden="true"></i> Facebook</A>
                    <A className="fbLink" href="https://twitter.com/home" mui='true'><i className="fa fa-twitter" aria-hidden="true"></i> Twitter</A>
                    
                </div>
            </div>
});

class ChetanCamper extends React.Component {
    static getStores() {
		return [OrderStore, ProductStore];
    }

    static calculateState(prevState) {
		let newState = {
                orders: OrderStore.getActionOrders(OrderAction.LOAD_CHETAN_CAMPAGIN_ORDERS),
                featuredProducts: ProductStore.getStoreProducts(CHETAN_STORE),
                openFeaturedProducts: prevState? prevState.openFeaturedProducts: false
			};
		return newState;
	}
    
    constructor(props){
		super(props);
		this.state = {copied: false, openFeaturedProducts: false};
        this.onCopy = this.onCopy.bind(this);
        this.onContributeNowClick = this.onContributeNowClick.bind(this);
        this.onFeaturedProductsModalClose = this.onFeaturedProductsModalClose.bind(this);

        this.getCampaignStat = this.getCampaignStat.bind(this);
    }

    componentDidMount() {	
        if(!this.state.orders) {
            AdAPI.getChetanCampaignOrders();
        }
    }

    onCopy() {
        this.setState({copied: copy(CAMPAIGN_URL)});
    }

    onContributeNowClick() {
        this.setState({openFeaturedProducts: true});

        if(!this.state.featuredProducts) {
            HttpService.getStoreProducts(CHETAN_STORE);
        }
    }

    onFeaturedProductsModalClose() {
        this.setState({openFeaturedProducts: false});
    }
    
    getCampaignStat() {
        if(this.state.orders) {
            const totalFulfilled = this.state.orders.size;
            return {totalFulfilled: totalFulfilled, 
                    totalRemaining: TOTAL_ORDERS_TARGET - totalFulfilled};
        }    

        return {totalFulfilled: "-", totalRemaining: "-"};
    }

    render() {
        const campaignStat = this.getCampaignStat();

        return <div id="chetanCampaignPage">
					<Helmet>
						<title>Purchase Chetan Vlog Merch and You can help him build his Camper Project | Seto Canvas</title>
    					<meta name="description" content="Support Chetan Vlog by purchasing any one of his Merch. All profits made from the Merch. will go directly to help him build his Camper." />
					</Helmet>

                    <HeaderContainer />
                    <br />
                    <div className="mainContainer">
                        <div id="campaignHeader" className="flexRow" style={{"@media (max-width: 884px)": {height: 'auto'}}}>
                            <Img src="/images/banners/chetan-camper/Camper Small Banner.png" id="camperImg" style={{width: '720px'}}/>
                            

                            <div style={{'@media (min-width: 884px)': {display: 'none'}}} id="mobileStat">
                                <CampaignStat campaignStat={campaignStat} 
                                                        onContributeNowClick={this.onContributeNowClick} 
                                                        copied={this.state.copied} onCopy={this.onCopy} />
                            </div>
                            <div style={{'@media (max-width: 884px)': {display: 'none'}}} id="webStat">
                                <Sticky topOffset={128}>
                                    {({style, isSticky}) => {
                                        style.margin = '0 10px';
                                        style.width = 'inherit';
                                        style.top = '60px';

                                        return <CampaignStat style={style} campaignStat={campaignStat} 
                                                        onContributeNowClick={this.onContributeNowClick} 
                                                        copied={this.state.copied} onCopy={this.onCopy} />
                                    }} 
                                </Sticky>
                            </div>
                            

                        </div>


                        <div id="campaignBody" className="flexColumn">
                            
                            <div style={{width: "60%", "@media (max-width: 884px)": {width: '100%'}}}>
                                <p id="campaignInfo">
                                    <span id="highlightedMsg">Our beloved Chetan Raj Karki a.k.a Chetan Vlog has been embarking on a project that seems to be one of its Kind in Nepal.</span>
                                    <span>To help him build this project, we, Seto Canvas, will be donating all the profit made on the purchase of <b>Chetan Vlog Merchandise.</b></span>
                                    <span>We aim to target <b>100 orders</b> and we need <b>YOUR HELP to reach that target</b>. Simply purchase any Merchandise from <A href={"/store/"+CHETAN_STORE}>Chetan Vlog Store</A> and for every orders delivered, the profit made will go directly to Chetan Vlog Camper project.</span>
                                </p>
                                
                                <h1><b>Contributers List <i className="fa fa-thumbs-o-up" aria-hidden="true"></i></b></h1>

                                <Separator style={{margin: '0px auto 25px auto', width: '100%'}} />
                                
                                <ContributersList contributers={this.state.orders} />

                                <div id="contributeNowSecondBtn">
                                    <Button onClick={this.onContributeNowClick} mui='true' color='primary'>Contribute Now</Button>
                                </div>
                                <br />
                            </div>
                        </div>
                    </div>
                    

                    <FeaturedProductsModal open={this.state.openFeaturedProducts} products={this.state.featuredProducts} onClose={this.onFeaturedProductsModalClose} />
                    <Footer />
        </div>
    }
}

export default Radium(Container.create(ChetanCamper));


// WEBPACK FOOTER //
// ./src/pages/campaigns/ChetanCamper.js